//Model for:
//  • Product
//  • ProductResponse

export class Product {
  product_id: number;
  sku: string;
  active: boolean;
  category: string;
  image_summary: string;
  image_detail1: string;
  product_title: string;
  product_htmltitle: string;  //not used
  product_subtitle: string;
  product_summary: string;
  product_description: string;
  product_unit_info: string;
  product_price: number;
  paypal_code: string;
  created_at: string;
  updated_at: string;

  // Previously failed attempting to cast FirebaseListObservable to Products[].
  constructor(product_id: number=undefined,
    sku: string='',
    active: boolean=false,
    category: string='',
    image_summary: string='',
    image_detail1: string='',
    product_title: string='',
    product_htmltitle: string='',
    product_subtitle: string='',
    product_summary: string='',
    product_description: string='',
    product_unit_info: string='',
    product_price: number=0,
    paypal_code: string='',
    created_at: string='',
    updated_at: string=''
  ){
    //typescript will not autoassign the formal parameters to related properties for exported classes.
    this.product_id = product_id;
    this.sku = sku;
    this.active = active;
    this.category = category;
    this.image_summary = image_summary;
    this.image_detail1 = image_detail1;
    this.product_title = product_title;
    this.product_htmltitle = product_htmltitle;
    this.product_subtitle = product_subtitle;
    this.product_summary = product_summary;
    this.product_description = product_description;
    this.product_unit_info = product_unit_info;
    this.product_price = product_price;
    this.paypal_code = paypal_code;
    this.created_at = created_at;
    this.updated_at = updated_at;
  }

  // static filterOut(id:number, products:Product[]):Product[]{
  //   let filteredProducts = products.filter((product) => {
  //     return product.product_id != id;
  //   });
  //   return filteredProducts; 
  // }

  //Sorts by SKU
  static productSortFunction = (a,b) => {
    if(a.sku > b.sku){return 1}
    else if(a.sku < b.sku){return -1}
    else {return -1}
  }


  static filterActiveProducts(products:Product[]){
    let activeProducts = null;
    if (products){
      activeProducts = products.filter((product) => {
        return product.active == true;
      });
    }
    // console.log('activeProducts', activeProducts);
    return activeProducts;
  }

  differencesWithEditedProduct(editedProduct:Product){
    let mods = {};
    let productProperties = Object.keys(this);
    for (let property of productProperties){
      if (editedProduct[property] != this[property]) { 
        mods[property] = editedProduct[property] 
      }
    }
    return mods;
    
  }

  //returns mods that only contains data from allowedproperties
  reduceToAllowedProperties(allowedProperties){
    var mods = {};
    //iterate through allowedProperties "gracefully".  for-of iterates over the enumerable properties of an object; for-in does the same but includes inherited properties.
    for (let property of allowedProperties){
      if (this.hasOwnProperty(property)) { mods[property] = this[property] }
    }
    return mods;
  }

  
  //=========================
  //STATIC Class Methods
  


  //Class method to convert firebaselistobservables to pure array of Products
  //Caller: product.service:getProducts()
  static fromJsonList(products:any): Product[] {
    let mappedArray = products.map(Product.fromJson); 
    return mappedArray;
  }

  //add more parameters depending on your database entries and Hero constructor
  // *note: parameters must match the key-names of be those of the any[] firebase list object.  
  //        Thus '$key', 'firstName', etc.
  //  **note: the value passed in must be of type any.
  // note: returns a NEW product.  So that means you can use this to make copies of products (for product-edit components where you need to keep original product intact).
  static fromJson({ 
    product_id,
    sku,
    active,
    category,
    image_summary,
    image_detail1,
    product_title,
    product_htmltitle,
    product_subtitle,
    product_summary,
    product_description,
    product_unit_info,
    product_price,
    paypal_code, 
    created_at,
    updated_at
  }): Product {
    return new Product(
      product_id,
      sku,
      active,
      category,
      image_summary,
      image_detail1,
      product_title,
      product_htmltitle,
      product_subtitle,
      product_summary,
      product_description,
      product_unit_info,
      product_price,
      paypal_code,
      created_at,
      updated_at
    );
  }
}


export interface ProductResponse {
  success:boolean;
  msg:string;
  products?:Product[];
  product?:Product;
}



//===============
//Unused Code
// Decided to keep this in productService
  // //returns original products filtered by category, or null
  // static getProductsByCategory(products:Product[], category:string){
  //   console.log('filtering products '+ products +' on category ' + category);
  //   //guard against null products
  //   //filter by category
  //   if(products && category){
  //     let filteredproducts = products.filter((product) => {
  //       return product.category == category;
  //     });
  //     return filteredproducts; 
  //   } else {
  //     // console.log('null category, returning all products');
  //     return products;
  //   }
  // }


// WEBPACK FOOTER //
// ./src/app/models/Product.ts